import { useEffect } from "react";
import PropTypes from "prop-types";

import { alignItems } from "../../consts";

import { FlexContainers, WrapperContainer } from "../../components";
import LanguageSelector from "./components/LanguageSelector";

const defaultLanguage = { id: 0, title: "EN" };

const LanguageSelectorTemplate = ({
  languageList = [],
  errorLangsList = [],
  setLanguageList,
  selectedId = 0,
  setSelectedId,
  viewOnlyLangs = [],
  isEditDisabled = false,
  onAddLanguageCallback = () => {},
  onEditLanguageCallback = () => {},
  onDeleteLanguageCallback = () => {},
  children
}) => {
  useEffect(() => {
    if (languageList.length === 0) {
      setLanguageList([defaultLanguage]);
      setSelectedId(0);
    }
  }, [languageList]);

  const onEditLanguage = ({ id, language }) => {
    const newLangIdx = languageList.findIndex((lang) => lang.id === id);
    const newItems = [
      ...languageList.slice(0, newLangIdx),
      { ...languageList[newLangIdx], title: language },
      ...languageList.slice(newLangIdx + 1)
    ];

    setLanguageList(newItems);
    setSelectedId(id);

    onEditLanguageCallback(id);
  };

  const onAddLanguage = (language) => {
    const newId = languageList?.length > 0 ? languageList[languageList.length - 1].id + 1 : 0;
    const newItems = [...languageList, { id: newId, title: language }];

    setLanguageList(newItems);
    setSelectedId(newId);

    onAddLanguageCallback(newId);
  };

  const onDeleteLanguage = (id) => {
    const newLanguageList = languageList.filter((lang) => lang.id !== id);
    setLanguageList(newLanguageList);

    if (selectedId === id) {
      setSelectedId(newLanguageList[0].id);
    }

    onDeleteLanguageCallback(id);
  };

  return (
    <WrapperContainer
      Container={FlexContainers.FlexRowStart}
      alignItems={alignItems.start}
      gap={16}
      width="100%"
      height="100%">
      <LanguageSelector
        languageList={languageList}
        errorLangsList={errorLangsList}
        selectedId={selectedId}
        viewOnlyLangs={viewOnlyLangs}
        isEditDisabled={isEditDisabled}
        setSelectedId={setSelectedId}
        onAddLanguage={onAddLanguage}
        onEditLanguage={onEditLanguage}
        onDeleteLanguage={onDeleteLanguage}
      />

      {children}
    </WrapperContainer>
  );
};

LanguageSelectorTemplate.propTypes = {
  languageList: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired, title: PropTypes.string.isRequired })
  ).isRequired,
  errorLangsList: PropTypes.arrayOf(PropTypes.string),
  setLanguageList: PropTypes.func.isRequired,
  selectedId: PropTypes.number.isRequired,
  setSelectedId: PropTypes.func.isRequired,
  viewOnlyLangs: PropTypes.arrayOf(PropTypes.string).isRequired,
  isEditDisabled: PropTypes.bool,
  onAddLanguageCallback: PropTypes.func,
  onEditLanguageCallback: PropTypes.func,
  onDeleteLanguageCallback: PropTypes.func,
  children: PropTypes.node.isRequired
};

export default LanguageSelectorTemplate;
